module.exports = __webpack_public_path__ + "static/media/apng_garm.5335e970.png";